import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchGoods, fetchCategories, setActiveCategory } from '../../action/goods';
import ReactTooltip from "react-tooltip";
import { fromStore } from "../../selectors";
import { isEmpty } from "lodash";
import Loader from "../utils/Loader";
import { styles } from "../../containers/goods/styles";
import '../../styles/neworder.css'
import { fetchPromotions, fetchSettings } from "../../action/app";
import Categories from "./Categories";
import Goods from "./Goods";
import DetailNewOrder from "./DetailNewOrder";
import { fetchFilials } from "../../action/handbook";
import OrderPositionList from "./OrderPositionList";
import { addPositionNewOrder, changeIsAggPriceNewOrder, clearNewOrder, openEditOrder } from "../../action/neworder";
import { fetchOrder } from "../../action/orders";
import { roleId, urls } from "../../constants/app";
import request from "../../action/utils/request";
import { setUIvisible } from "../../action/UImobile";
import { checkSorucePromotions, validatePromotions } from "../../utils/common";
import { clearHistoryOrders } from "../../action/historyOrders";

function NewOrder() {
    const dispatch = useDispatch();
    const loadingGoods = useSelector(fromStore.loaderGoodsSelector);
    const settings = useSelector(state => state.settings.init);
    const goodsChek = useSelector(state => state.good.list);
    const loadingCategories = useSelector(fromStore.loaderCategoriesSelector);
    const categories = useSelector(fromStore.categoryListSelector);
    const activeCategory = useSelector(fromStore.activeCategorySelector);    
    const loadingFilials = useSelector(state => state.loaders.filials);
    const loadingWorkingShift = useSelector(state => state.loaders.workingShift);
    const neworders = useSelector(state => state.neworders)
    const loadingSaveOrder = useSelector(state => state.loaders.loadingSaveOrder);
    const editedOrder = useSelector(state => state.orders.detail);
    const filials = useSelector(state => state.handbook.filials);
    const user = useSelector(state => state.user.info);
    const promotions = useSelector(state => state.promotions.list);
    const historyOrders = useSelector(state => state.historyOrders.list);
    
    const [goods, setGoods] = useState([]);
    const [searchGoods, setSearchGoods]  = useState(null);
    const [searchingGoods, setSearchingGoods]  = useState(null);
    const [editOrder, setEditOrder] = useState(false);
    const [activeTabMobile, setActiveTabMobile] = useState('detail');
    const [availablePromotions, setAvailablePromotions] = useState([]);
    const [availableCategories, setAvailableCategories] = useState([]);

    const getOrderPointId = (item) => {
        let pointId;

        if (item.point) {
            if (typeof item.point === 'object' &&  item.point.id) {
                pointId = item.point.id;
            } else {
                pointId = item.point;
            }
        } else if (item.zone && item.zone.point) {
            if (typeof item.zone.point === 'object' &&  item.zone.point.id) {
                pointId = item.zone.point.id;
            } else {
                pointId = item.zone.point;
            }
        }

        return pointId;
    }

    const getCity = (item) => {
        if (!item.point && !item.zone) return null;
        if(item.zone && !item.zone.point.id && !filials.find((el) => el.id === item.zone.point)) return null;
        const pointId = getOrderPointId(item);
        
        if (!pointId) return null;
        const entity = filials.find((fil) => fil.id === pointId);
        if (isEmpty(entity)) return null;

        return entity.city;    
    }

    useEffect(() => {
        if (!settings || !settings.promotions) return setAvailablePromotions([]);
        const city = getCity(neworders);
        const sum = neworders.goodsPrice != null ? neworders.goodsPrice : neworders.totalPrice;
        const result = promotions.filter(validatePromotions(city, neworders.deliveryMethod, sum, historyOrders, true));
        return setAvailablePromotions(result);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [promotions, neworders.city, neworders.point, neworders.totalPrice, neworders.goods, settings, neworders.deliveryMethod, historyOrders])

    const onSelectCategory = (id) => () => {        
        dispatch(setActiveCategory(id));            
    };

    const checkModPrice = (field, good, mod) => {
        if(mod.default) {
            if(field === 'price') 
                return good.defaultPrice;
            return good.defaultOldPrice; 
        }
            if(mod.active) {
                switch(mod.condition) {
                    case('equal'): {
                    if(mod[field]) {
                        return mod[field];
                    } else {
                        if(good[field])
                            return good[field];
                        return null;
                    }
                }
                case('plus'): {
                    if(good[field]) {
                        if(mod[field]) {
                                return Math.round((good[field] + mod[field]).toFixed(0));
                        } else {
                            return good[field];
                        }
                    } else {
                        return null;
                    }
                }
                case('minus'): {
                    if(good[field]) {
                        if(mod[field]) {
                            return Math.round((good[field] - mod[field]).toFixed(0));
                        } else {
                            return good[field];
                        }
                    } else {
                        return null;
                    }
                }
                case('multiply'): {
                    if(good[field]) {
                        if(mod[field]) {
                            return Math.round((good[field] * mod[field]).toFixed(0));
                        } else {
                            return good[field];
                        }
                    } else {
                        return null;
                    }
                }                
                    default: {
                    if(good[field]) {
                        return good[field]; 
                        } else {
                            return null;
                        }
                    }
                }
            } else {
                return null;
            }
    }

    const changeOptionGroup = (index, targetId) => {
        const updatedGoods = goods.map((item, goodIndex) => {
            if (goodIndex === index && item.isGroup) {
                const targetoption = item.items.find((option) => option.id === targetId);
                return {
                    ...targetoption,
                    active: item.active,
                    isGroup: true,
                    title: item.title,
                    items: item.items,
                    groupId: item.groupId,
                };
            };

            return item;
        });

        setGoods(updatedGoods);
    }

    const changeModification = (id, mod) => {       
            const updatedGoods = goods.map(item =>
                item.id === id ? { 
                    ...item, 
                    id: !mod.default ? `${item.id}_${mod.id}` : (String(item.id).split('_')[0] ? String(item.id).split('_')[0] : item.id),
                    isMod: !mod.default,
                    defaultPrice: !mod.default ? item.price : item.defaultPrice,
                    defaultOldPrice: !mod.default ? item.oldPrice : item.defaultOldPrice,
                    price: checkModPrice('price', item, mod),
                    oldPrice: checkModPrice('oldPrice', item, mod)
                } : item
            );
        
        setGoods(updatedGoods);
    }

    const checkRegionPrice = (field, good, regionPrice) => {
        if(regionPrice.active) {
            switch(regionPrice.condition) {
                case('equal'): {
                    if(regionPrice[field]) {
                        return regionPrice[field];
                    } else {
                        if(good[field])
                            return good[field];
                        return null;
                    }
                }
                case('plus'): {
                    if(good[field]) {
                        if(regionPrice[field]) {
                            if(regionPrice.persent)                        
                                    return Math.round((good[field] + (good[field] / 100 * regionPrice[field])));
                                return Math.round((good[field] + regionPrice[field]).toFixed(0));
                        } else {
                            return good[field];
                        }
                    } else {
                        return null;
                    }
                }
                case('minus'): {
                    if(good[field]) {
                        if(regionPrice[field]) {
                            if(regionPrice.persent)
                                return Math.round((good[field] - (good[field] / 100 * regionPrice[field])).toFixed(0));
                            return Math.round((good[field] - regionPrice[field]).toFixed(0));
                        } else {
                            return good[field];
                        }
                    } else {
                        return null;
                    }
                }
                case('multiply'): {
                    if(good[field]) {
                        if(regionPrice[field]) {
                            return Math.round((good[field] * regionPrice[field]).toFixed(0));
                        } else {
                            return good[field];
                        }
                    } else {
                        return null;
                    }
                }                
                    default: {
                    if(good[field]) {
                        return good[field]; 
                        } else {
                            return null;
                        }
                    }
            }
        } else {
            return good[field];
        }
    }

    const filterGoods = useCallback(() => {
        if(settings && settings.categories && activeCategory !== settings.categories.wok)
            if(!neworders.point) {
                setGoods(goodsChek.filter((item) => item.category.id === activeCategory)
                    .filter((item) => {
                        if (!item.active) return false;
                        if (item.isGroup && isEmpty(item.items)) return false;
                        return true;
                    })
                    .sort((a, b) => {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    })
                );
            } else {
                setGoods(goodsChek.filter((item) => item.category.id === activeCategory)
                    .filter((item) => {
                        if (!item.active) return false;
                        if (item.isGroup && isEmpty(item.items)) return false;
                        return true;
                    })
                    .sort((a, b) => {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    })
                    .filter((item) => { //проверка на доступность позиции в городе
                        const disabledCityIds = item.disabledCities ? item.disabledCities.split(',') : [];
                        const currentCity = getCity(neworders);
                        if (!currentCity) return true;
                        return !disabledCityIds.some((id) => parseInt(id) === +currentCity.id);
                    })
                    .map((item) => {
                        const currentCity = getCity(neworders);
                        if (!item.isGroup) {
                            if (currentCity && item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))) {
                                return { 
                                    ...item, 
                                    price: checkRegionPrice('price', item, item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))), 
                                    oldPrice: checkRegionPrice('oldPrice', item, item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))),
                                } 
                            }
                            return item;
                        } else {
                            const items = item.items.filter((option) => { //проверка на доступность позиции в городе
                                const disabledCityIds = option.disabledCities ? option.disabledCities.split(',') : [];
                                const currentCity = getCity(neworders);
                                if (!currentCity) return true;
                                return !disabledCityIds.some((id) => parseInt(id) === +currentCity.id);
                            }).map((option) => {
                                if (currentCity && option.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))) {
                                    return { 
                                        ...option, 
                                        price: checkRegionPrice('price', option, option.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))), 
                                        oldPrice: checkRegionPrice('oldPrice', option, option.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))),
                                    } 
                                }
                                return option;
                            });

                            if (currentCity && item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))) {
                                return { 
                                    ...item, 
                                    price: checkRegionPrice('price', item, item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))), 
                                    oldPrice: checkRegionPrice('oldPrice', item, item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))),
                                    items,
                                } 
                            }
                            return { ...item, items };
                        }
                    })
                );                
            }

        if(settings && settings.categories && activeCategory === settings.categories.wok)            
            if(!neworders.point) {
                setGoods(goodsChek.filter((item) => item.active && (item.category.id === activeCategory || item.category.id === settings.categories.mainWok))
                        .sort((a, b) => {
                            if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                            if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                            return 0;
                        })
                            .sort((a, b) => b.category.id - a.category.id)
                            .map((item) => 
                                item.category.id === settings.categories.mainWok 
                                ?
                                { ...item, isWok: true }
                                :
                                item
                            )
                        );
            } else {
                setGoods(goodsChek.filter((item) => item.active && (item.category.id === activeCategory || item.category.id === settings.categories.mainWok))
                    .sort((a, b) => {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    })
                        .sort((a, b) => b.category.id - a.category.id)
                        .map((item) => {
                            return { ...item, isWok: true }
                        })
                        .filter((item) => { //проверка на доступность позиции в городе
                            const disabledCityIds = item.disabledCities ? item.disabledCities.split(',') : [];
                            const currentCity = getCity(neworders);
                            if (!currentCity) return true;
                            return !disabledCityIds.some((id) => parseInt(id) === +currentCity.id);
                        })
                        .map((item) => {
                            const currentCity = getCity(neworders);
                            if (!item.isGroup) {
                                if (currentCity && item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))) {
                                    return { 
                                        ...item, 
                                        price: checkRegionPrice('price', item, item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))), 
                                        oldPrice: checkRegionPrice('oldPrice', item, item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))),
                                    } 
                                }
                                return item;
                            } else {
                                const items = item.items.filter((option) => { //проверка на доступность позиции в городе
                                    const disabledCityIds = option.disabledCities ? option.disabledCities.split(',') : [];
                                    const currentCity = getCity(neworders);
                                    if (!currentCity) return true;
                                    return !disabledCityIds.some((id) => parseInt(id) === +currentCity.id);
                                }).map((option) => {
                                    if (currentCity && option.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))) {
                                        return { 
                                            ...option, 
                                            price: checkRegionPrice('price', option, option.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))), 
                                            oldPrice: checkRegionPrice('oldPrice', option, option.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))),
                                        } 
                                    }
                                    return option;
                                });
    
                                if (currentCity && item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))) {
                                    return { 
                                        ...item, 
                                        price: checkRegionPrice('price', item, item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))), 
                                        oldPrice: checkRegionPrice('oldPrice', item, item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))),
                                        items,
                                    } 
                                }
                                return { ...item, items };
                            }
                        })
                    );
            }
                // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCategory, goodsChek, settings, neworders.point]); 

    useEffect(() => {
        filterGoods();
        dispatch(setUIvisible(false, false))
    }, [filterGoods, dispatch]);

    useEffect(() => {
        const city = getCity(neworders);
        const result = categories.filter((category) => {
            if (city && city.id && category.disabledCities) {
                const dCities = category.disabledCities.split(',');
                if (dCities.length !== 0 && dCities.includes(String(city.id))) {
                    return false;
                }
            }
            
            const avaibleGoods = goodsChek.filter((item) => {
                if (!item.active) return false;
                if(+item.category.id !== +category.id) return false;
                if (city && city.id && item.disabledCities) {
                    const dCities = item.disabledCities.split(',');
                    if (dCities.length !== 0 && dCities.includes(String(city.id))) {
                        return false;
                    }
                }
                return true;
            });
            if (!avaibleGoods || avaibleGoods.length <= 0) return false;
            return true;
        });

        setAvailableCategories(result);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [promotions, neworders.city, neworders.point, categories, goodsChek]);

    useEffect(() => {
        if(searchGoods && goodsChek)
            setSearchingGoods(goodsChek.filter(good => good.active && !good.isGroup && good.name.trim().toLowerCase().replace(/[,\s.]/gi, '').includes(searchGoods.trim().toLowerCase().replace(/[,\s.]/gi, '')))
            .filter((item) => { //проверка на доступность позиции в городе
                const city = getCity(neworders);
                if (city && item.disabledCities) {
                    const dCities = item.disabledCities.split(',');
                    if (dCities.includes(String(city.id))) {
                      return false
                    }
                }
                if (city && item.category.disabledCities) {
                    const dCities = item.category.disabledCities.split(',');
                    if (dCities.includes(String(city.id))) {
                        return false
                    }
                }
                return true;
            }).slice(0, 5)
            .map((item) => {
                const currentCity = getCity(neworders);
                if (currentCity && item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))) {
                    return { 
                        ...item, 
                        price: checkRegionPrice('price', item, item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))), 
                        oldPrice: checkRegionPrice('oldPrice', item, item.regionprices.find((regionprices) => regionprices.cities.some((item) => parseInt(item.id) === +currentCity.id))),
                    } 
                }
                return item;
            })
        )
            
        if(!searchGoods)
            setSearchingGoods(null)
            // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchGoods, goodsChek, neworders.point])

    useEffect(() => {
        if(window.location.pathname.includes('/edit')) {
            const currentUrl = window.location.href;
            const urlParts = currentUrl.split('/');
            const id = urlParts[urlParts.length - 1];

            setEditOrder(true);
            if(window.location.pathname.includes('/orders'))
                dispatch(fetchOrder(id, false));
            if(window.location.pathname.includes('/archive'))
                dispatch(fetchOrder(id, true));
        } else {
            setEditOrder(false);
            dispatch(clearNewOrder());
            dispatch(clearHistoryOrders());
        }

        return () => {
            setEditOrder(false);
            dispatch(clearNewOrder());
            dispatch(clearHistoryOrders());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    useEffect(() => {
        const checkFilial = async () => {
            if(editedOrder.point) 
                return editedOrder.point;

            if(editedOrder.zone && editedOrder.zone.point) {
                if(editedOrder.zone.point.id) {
                    return editedOrder.zone.point;
                } else {
                    if(filials.length > 0) {
                       return await filials.find((filial) => filial.id === editedOrder.zone.point);
                    } else {
                        return await request({ method: 'get', url: `${urls.filials}/${editedOrder.zone.point}` });
                    }
                }
            }

            if(!editedOrder.point && !editedOrder.zone) {
                return null;
            }
        }

        const fetchFilialAndDispatch = async () => {
                const point = await checkFilial();
                await clearNewOrder(); 
                dispatch(openEditOrder(editedOrder, point, goodsChek)); 
        };

        if (window.location.pathname.includes('/edit') && editOrder && !isEmpty(editedOrder)) {
            fetchFilialAndDispatch(); 
        } else {
            dispatch(clearNewOrder())
            dispatch(clearHistoryOrders());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editedOrder, dispatch])

    useEffect(() => ReactTooltip.rebuild(), [goods, loadingGoods]);

    useEffect(() => {   
        isEmpty(settings) && dispatch(fetchSettings());
        isEmpty(goodsChek) && dispatch(fetchGoods());
        isEmpty(categories) && dispatch(fetchCategories());
        dispatch(fetchFilials(null, true));
        dispatch(fetchPromotions(checkSorucePromotions(user.role.id), true));
        return () => {
            dispatch(clearNewOrder());
            dispatch(clearHistoryOrders());
            setEditOrder(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const renderContent = () => {
        if(loadingGoods || loadingCategories || loadingFilials || loadingWorkingShift)
            return(
                <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                    <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
                </div>
            )

        if(loadingSaveOrder)
            return(
                <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                    <div style={styles.tableLoading}><Loader text='Сохраняю заказ'/></div>
                </div>
            )

        return(
            <div className='kt-container neworder kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop neworder">
                    <div className='neworder_container order_position_list'>
                        <OrderPositionList editOrder={editOrder} editedOrder={editedOrder} loadingGoods={loadingGoods} goods={goodsChek} availablePromotions={availablePromotions} />
                    </div>
                    <div className='neworder_container detail' >
                        <DetailNewOrder editOrder={editOrder}/>
                    </div>
                    <div className='neworder_container categories'>
                       <Categories categories={availableCategories} activeCategory={activeCategory} onSelectCategory={onSelectCategory}/>
                    </div>
                    <div className="neworder_good_main">
                        <div className='neworder_good_head'>                            
                            <div style={{display: "flex", gap: '10px', alignItems: 'center', marginTop: '10px'}}>
                                {(!editOrder || user.role.id !== roleId.cashier) &&
                                <>
                                    <label>{window.innerWidth > 1210 ? 'Цены агрегаторов' : 'Цены аг.'}</label>
                                    <div>
                                        <span className="kt-switch kt-switch--sm kt-switch--icon">
                                        <label>
                                            <input 
                                            type="checkbox" 
                                            checked={neworders.isAggPrice} 
                                            onChange={(e) => dispatch(changeIsAggPriceNewOrder(e.target.checked, goodsChek))} 
                                            />
                                            <span className="new_order_switch"></span>
                                        </label>
                                        </span>
                                    </div>
                                </>
                                }
                            </div>
                            <div className="neworder_good_head_search_block">
                                {neworders.point && goodsChek &&
                                    <>
                                        <input 
                                            type="text"
                                            className="form-control search"
                                            autocomplete="false"
                                            placeholder="Поиск"
                                            value={searchGoods}
                                            onChange={((e) => setSearchGoods(e.target.value))}
                                            onBlur={(() => setSearchGoods(''))}                                            
                                        />
                                        {searchGoods && searchingGoods && searchingGoods.length > 0 &&
                                            <div className="new_order_search_div">
                                                <div className="new_order_search_container">
                                                    {searchingGoods.map((item) => 
                                                        <button
                                                        className={`new_order_search_button ${(neworders.point.stopList ? neworders.point.stopList : []).some((el) => el.value === item.id) ? 'unactived' : ''}`}
                                                        onMouseDown={((e) => e.preventDefault())}
                                                        onClick={(() => {
                                                            if(!(neworders.point.stopList ? neworders.point.stopList : []).some((el) => el.value === item.id))
                                                            {
                                                                dispatch(addPositionNewOrder({...item, price: !neworders.isAggPrice ? item.price : item.oldPrice || item.price}, settings.categories));
                                                                setSearchGoods('');
                                                            }
                                                        })}
                                                        >
                                                            <span className="neworder_good_button_text" >{item.name}</span>
                                                            {!neworders.isAggPrice 
                                                            ?
                                                            <span className="neworder_good_button_text" style={{ fontWeight: '600', fontSize: '0.9rem' }}> {`${item.isMod ? item.price + item.isMod.price : item.price} ₽`} </span>
                                                            :
                                                            <span className="neworder_good_button_text" style={{ fontWeight: '600', fontSize: '0.9rem' }}> {`${item.isMod ? item.oldPrice + item.isMod.oldPrice : item.oldPrice} ₽`} </span>
                                                            }
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                        <div className='neworder_container goods'>
                            <Goods loadingGoods={loadingGoods} goods={goods} changeModification={changeModification} changeOptionGroup={changeOptionGroup} setActiveTabMobile={setActiveTabMobile}/>
                            <ReactTooltip
                                effect="solid"
                                type="dark"
                                place="top"
                            />       
                        </div>  
                    </div>    
                </div>
            </div>
        )
    }

    const renderleftPanelMobile = () => {
        if(activeTabMobile === 'detail')
            return(
                <div className='neworder_container detail'>
                    <DetailNewOrder editOrder={editOrder}/>
                </div>
            );

        if(activeTabMobile === 'goods') {
            if(window.innerWidth > 650)
                setActiveTabMobile('detail')
            return (<div className="neworder_container goods_mobile">
                <div className="neworder_container categories">
                       <Categories categories={availableCategories} activeCategory={activeCategory} onSelectCategory={onSelectCategory}/>
                    </div>
                    <div className="neworder_good_main">
                        <div className='neworder_good_head'>                            
                            <div style={{display: "flex", gap: '10px', alignItems: 'center', marginTop: '10px'}}>
                                {(!editOrder || user.role.id !== roleId.cashier) &&
                                    <>
                                        <label>{window.innerWidth > 1210 ? 'Цены агрегаторов' : 'Цены аг.'}</label>
                                        <div>
                                            <span className="kt-switch kt-switch--sm kt-switch--icon">
                                            <label>
                                                <input 
                                                type="checkbox" 
                                                checked={neworders.isAggPrice} 
                                                onChange={(e) => dispatch(changeIsAggPriceNewOrder(e.target.checked, goodsChek))} 
                                                />
                                                <span className="new_order_switch"></span>
                                            </label>
                                            </span>
                                        </div>
                                    </>
                                    }
                            </div>
                            <div className="neworder_good_head_search_block">
                                {neworders.point && goodsChek &&
                                    <>
                                        <input 
                                            type="text"
                                            className="form-control search"
                                            autocomplete="false"
                                            placeholder="Поиск"
                                            value={searchGoods}
                                            onChange={((e) => setSearchGoods(e.target.value))}
                                            onBlur={(() => setSearchGoods(''))}                                            
                                        />
                                        {searchGoods && searchingGoods && searchingGoods.length > 0 &&
                                            <div className="new_order_search_div">
                                                <div className="new_order_search_container">
                                                    {searchingGoods.map((item) => 
                                                        <button
                                                        className={`new_order_search_button ${(neworders.point.stopList ? neworders.point.stopList : []).some((el) => el.value === item.id) ? 'unactived' : ''}`}
                                                        onMouseDown={((e) => e.preventDefault())}
                                                        onClick={(() => {
                                                            if(!(neworders.point.stopList ? neworders.point.stopList : []).some((el) => el.value === item.id))
                                                            {
                                                                dispatch(addPositionNewOrder({...item, price: !neworders.isAggPrice ? item.price : item.oldPrice || item.price}, settings.categories));
                                                                setSearchGoods('');
                                                            }
                                                        })}
                                                        >
                                                            <span className="neworder_good_button_text" >{item.name}</span>
                                                            {!neworders.isAggPrice 
                                                            ?
                                                            <span className="neworder_good_button_text" style={{ fontWeight: '600', fontSize: '0.9rem' }}> {`${item.isMod ? item.price + item.isMod.price : item.price} ₽`} </span>
                                                            :
                                                            <span className="neworder_good_button_text" style={{ fontWeight: '600', fontSize: '0.9rem' }}> {`${item.isMod ? item.oldPrice + item.isMod.oldPrice : item.oldPrice} ₽`} </span>
                                                            }
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                        <div className="neworder_container goods">
                            <Goods loadingGoods={loadingGoods} goods={goods} changeModification={changeModification} changeOptionGroup={changeOptionGroup} setActiveTabMobile={setActiveTabMobile}/>
                            <ReactTooltip
                                effect="solid"
                                type="dark"
                                place="top"
                            />       
                        </div>  
                    </div> 
            </div>);
        }

        return (
            <div className="neworder_container order_position_list">         
                <OrderPositionList editOrder={editOrder} editedOrder={editedOrder} loadingGoods={loadingGoods} goods={goodsChek} availablePromotions={availablePromotions} />
            </div>
        );
    }

    const renderContentTablet = () => {
        if(loadingGoods || loadingCategories || loadingFilials || loadingWorkingShift)
            return(
                <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                    <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
                </div>
            )

        if(loadingSaveOrder)
            return(
                <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                    <div style={styles.tableLoading}><Loader text='Сохраняю заказ'/></div>
                </div>
            )

        return(
            <div className='kt-container neworder kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '5px'}}>
                        <div className="tab_mobile-buttons_container">
                            <button 
                            className={`tab_mobile-button ${activeTabMobile === 'positionList' ? ' active' : ''}`}
                            onClick={(() => setActiveTabMobile('positionList'))}
                            >
                                Заказ
                            </button>
                            <button 
                            className={`tab_mobile-button ${activeTabMobile === 'detail' ? ' active' : ''}`}
                            onClick={(() => setActiveTabMobile('detail'))}
                            >
                                Детали
                            </button>                            
                        </div>                
                    <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop neworder">

                        {renderleftPanelMobile()}                      

                        <div className="neworder_container categories">
                        <Categories categories={availableCategories} activeCategory={activeCategory} onSelectCategory={onSelectCategory}/>
                        </div>
                        <div className="neworder_good_main">
                            <div className='neworder_good_head'>                            
                                <div style={{display: "flex", gap: '10px', alignItems: 'center', marginTop: '10px'}}>
                                    {(!editOrder || user.role.id !== roleId.cashier) &&
                                    <>
                                        <label>{window.innerWidth > 1210 ? 'Цены агрегаторов' : 'Цены аг.'}</label>
                                        <div>
                                            <span className="kt-switch kt-switch--sm kt-switch--icon">
                                            <label>
                                                <input 
                                                type="checkbox" 
                                                checked={neworders.isAggPrice} 
                                                onChange={(e) => dispatch(changeIsAggPriceNewOrder(e.target.checked, goodsChek))} 
                                                />
                                                <span className="new_order_switch"></span>
                                            </label>
                                            </span>
                                        </div>
                                    </>
                                    }
                                </div>
                                <div className="neworder_good_head_search_block">
                                    {neworders.point && goodsChek &&
                                        <>
                                            <input 
                                                type="text"
                                                className="form-control search"
                                                autocomplete="false"
                                                placeholder="Поиск"
                                                value={searchGoods}
                                                onChange={((e) => setSearchGoods(e.target.value))}
                                                onBlur={(() => setSearchGoods(''))}                                            
                                            />
                                            {searchGoods && searchingGoods && searchingGoods.length > 0 &&
                                                <div className="new_order_search_div">
                                                    <div className="new_order_search_container">
                                                        {searchingGoods.map((item) => 
                                                            <button
                                                            className={`new_order_search_button ${(neworders.point.stopList ? neworders.point.stopList : []).some((el) => el.value === item.id) ? 'unactived' : ''}`}
                                                            onMouseDown={((e) => e.preventDefault())}
                                                            onClick={(() => {
                                                                if(!(neworders.point.stopList ? neworders.point.stopList : []).some((el) => el.value === item.id))
                                                                {
                                                                    dispatch(addPositionNewOrder({...item, price: !neworders.isAggPrice ? item.price : item.oldPrice || item.price}, settings.categories));
                                                                    setSearchGoods('');
                                                                }
                                                            })}
                                                            >
                                                                <span className="neworder_good_button_text" >{item.name}</span>
                                                                {!neworders.isAggPrice 
                                                                ?
                                                                <span className="neworder_good_button_text" style={{ fontWeight: '600', fontSize: '0.9rem' }}> {`${item.isMod ? item.price + item.isMod.price : item.price} ₽`} </span>
                                                                :
                                                                <span className="neworder_good_button_text" style={{ fontWeight: '600', fontSize: '0.9rem' }}> {`${item.isMod ? item.oldPrice + item.isMod.oldPrice : item.oldPrice} ₽`} </span>
                                                                }
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    }
                                </div>
                            </div>
                            <div className="neworder_container goods">
                                <Goods loadingGoods={loadingGoods} goods={goods} changeModification={changeModification} changeOptionGroup={changeOptionGroup} setActiveTabMobile={setActiveTabMobile}/>
                                <ReactTooltip
                                    effect="solid"
                                    type="dark"
                                    place="top"
                                />       
                            </div>  
                        </div>  
                    </div>
                </div>
            </div>            
        );
    }

    const renderContentMobile = () => {
        if(loadingGoods || loadingCategories || loadingFilials || loadingWorkingShift)
            return(
                <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                    <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
                </div>
            )

        if(loadingSaveOrder)
            return(
                <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                    <div style={styles.tableLoading}><Loader text='Сохраняю заказ'/></div>
                </div>
            )

        return(
            <div className='kt-container neworder kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '5px'}}>
                        <div className="tab_mobile-buttons_container">
                            <button 
                            className={`tab_mobile-button ${activeTabMobile === 'goods' ? ' active' : ''}`}
                            onClick={(() => setActiveTabMobile('goods'))}
                            >
                                Товары
                            </button>
                            <button 
                            className={`tab_mobile-button ${activeTabMobile === 'positionList' ? ' active' : ''}`}
                            onClick={(() => setActiveTabMobile('positionList'))}
                            >
                                Заказ
                                {parseFloat(neworders.totalPrice) > 0 && <div>
                                    <div className="tab_mobile-button_total-price">
                                        {parseFloat(neworders.totalPrice).toFixed(0)}
                                    </div>
                                </div>}
                            </button>
                            <button 
                            className={`tab_mobile-button ${activeTabMobile === 'detail' ? ' active' : ''}`}
                            onClick={(() => setActiveTabMobile('detail'))}
                            >
                                Детали
                            </button>                            
                        </div>                
                    <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop neworder"> 
                        {renderleftPanelMobile()}                        
                    </div>
                </div>
            </div>            
        );
    }
          

    if(window.innerWidth <= 640)
        return (
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor paddingTop-mobile">
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{padding: '0px 5px'}}>                
                    {renderContentMobile()}                                                    
                </div>
            </div>
        );
    
    if(window.innerWidth <= 930)
        return (
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor paddingTop-mobile">
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{padding: '0px 5px'}}>                
                    {renderContentTablet()}                                                    
                </div>
            </div>
        );

        return (
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor paddingTop-mobile">
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">                
                    {renderContent()}                                                    
                </div>
            </div>
        );
    
}

export default NewOrder;